import {
  selectNavigationData,
  selectNavigationIsLoading as selectNavigationIsLoadingFromSlice,
  selectNavigationHasFailed as selectNavigationHasFailedFromSlice,
  selectNavigationPrincipalKey as selectNavigationPrincipalKeyFromSlice,
} from '@skynet/data-navigation';
import type { NavigationState } from '@skynet/data-navigation';

interface Store {
  navigationPermissions: NavigationState;
}

export const selectNavigation = (state: Store) => selectNavigationData(state.navigationPermissions);

export const selectNavigationIsLoading = (state: Store) =>
  selectNavigationIsLoadingFromSlice(state.navigationPermissions);

export const selectNavigationHasFailed = (state: Store) =>
  selectNavigationHasFailedFromSlice(state.navigationPermissions);

export const selectNavigationPrincipalKey = (state: Store) =>
  selectNavigationPrincipalKeyFromSlice(state.navigationPermissions);
